import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  LinearProgress,
  Link,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { LabelWithControl } from "components/common/LabelControl";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { downloadType } from "data/data";
import { useDispatch, useSelector } from "react-redux";
import { showNotificationDialog } from "redux/actions/notificationActions";
import dayjs from "dayjs";
import AutoComplete from "components/common/AutoComplete";
import {
  All_LOCATION,
  CUSTOMER_ORDERS_REPORT_TYPE,
  DEPOT,
  ONLINE,
  STORE,
  WHOLESALE,
  PAGE,
} from "components/common/CONSTANTS";
import {
  postFileAccess,
  showErrorMessageByCode,
} from "services/commonServices";
import {
  CORRECT_VALUE_SELECTION,
  DOWNLOAD_SUCCESS,
  SOMS_API_KEY,
} from "services/CONSTANTS";
import { generateDownloadReport } from "services/downloadCustomerDemandsService";
import { encryptString } from "components/common/EncryptDecrypt";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";

export const DownloadCustomerOrders = () => {
  const [showDownloadUrl, setShowDownloadUrl] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [downloadFileTime, setDownloadFileTime] = useState("");
  const [showFileDownloadPopup, setShowFileDownloadPopup] = useState(false);
  const [customer, setCustomer] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [depotId, setDepotId] = useState("All");
  const [storeId, setStoreId] = useState("All");
  const [deliveryDateFrom, setDeliveryDateFrom] = useState();
  const [deliveryDateTo, setDeliveryDateTo] = useState();
  const [type, setType] = useState("all");
  const [orderId, setOrderId] = useState("");
  const [errors, setErrors] = useState(null);
  const [depoError, setDepoError] = useState(null);
  const [storeError, setStoreError] = useState(null);
  const [storeIdInputValue, setStoreIdInputValue] = React.useState("");
  const [storeIdOptions, setStoreIdOptions] = React.useState([All_LOCATION]);
  const [depotIdInputValue, setDepotIdInputValue] = React.useState("");
  const [depotIdOptions, setDepotIdOptions] = React.useState([All_LOCATION]);

  const dispatch = useDispatch();
  const userType = useSelector((state) => state.user);
  const { accessiblePages } = userType.userType;
  const loginResponse = userType.loginResponse;
  const { locationResponse } = useSelector((state) => state.locations);
  const toShowCustListRef = useRef([]);
  const [channelList, setChannelList] = useState([]);
  const [storeObjects, setStoreObjects] = useState([]);
  const [depotObjects, setDepotObjects] = useState([]);
  const [orderDate, setOrderDate] = useState();
  useEffect(() => {
    if (accessiblePages) {
      const channels = accessiblePages[PAGE.DOWNLOAD_CUSTOMER_DEMANDS.key];
      setChannelList(channels);
      const toShowCustList = [];
      const stores = [];
      const depots = [];
      locationResponse.forEach((location) => {
        if (channels.includes(location.channel.toLowerCase())) {
          toShowCustList.push(location);
        }
        if (location.locationType === STORE) {
          stores.push(location);
        }
        if (location.locationType === DEPOT) {
          depots.push(location);
        }
      });
      setStoreObjects(stores);
      setDepotObjects(depots);
      toShowCustListRef.current = toShowCustList;
      let customerListFinal = [
        { CustomerId: "All", CustomerName: "All", CustomerType: "wholesale" },
      ];
      toShowCustList.forEach((v) => {
        if (
          v.customerType.includes("AMZ") &&
          v.customerType !== "" &&
          v.channel !== ""
        ) {
          customerListFinal.push({
            CustomerId: "AMZ",
            CustomerName: "Amazon",
            CustomerType: v.channel.toLowerCase(),
          });
        } else if (
          v.customerType !== "" &&
          v.channel !== "" &&
          v.customerType !== "Retail Store"
        ) {
          customerListFinal.push({
            CustomerId: v.customerType,
            CustomerName: v.customerType,
            CustomerType: v.channel.toLowerCase(),
          });
        }
      });

      function uniqueList(data, key) {
        return [...new Map(data.map((x) => [key(x), x])).values()];
      }

      let finalListOfCustomerArray = uniqueList(
        customerListFinal,
        (it) => it.CustomerId
      );
      const removeWholesale = finalListOfCustomerArray.filter((x) => {
        return x.CustomerId !== "Wholesale" && x.CustomerName !== "Wholesale";
      });
      setCustomerList(
        removeWholesale
          .filter((x) => {
            return channels.includes(x.CustomerType);
          })
          .sort((a, b) =>
            a.CustomerName > b.CustomerName
              ? 1
              : b.CustomerName > a.CustomerName
              ? -1
              : 0
          )
      );
    }
  }, [accessiblePages, locationResponse]);

  useEffect(() => {
    if (channelList.length && customerList.length)
      setCustomer(customerList[0]?.CustomerId);
  }, [customerList, channelList]);

  useEffect(() => {
    const allCust = "All";

    if (customer === allCust) {
      setStoreIdOptions([
        All_LOCATION,
        ...storeObjects.filter(
          (x) =>
            (channelList.includes(x.channel.toLowerCase()) ||
              x.channel === "" ||
              x.channel.toLowerCase().includes(WHOLESALE)) &&
            !x.customerType.toLowerCase().includes("retail store")
        ),
      ]);
    } else if (customer.toLowerCase().includes(WHOLESALE)) {
      setStoreIdOptions([
        All_LOCATION,
        ...storeObjects.filter(
          (x) =>
            channelList.includes(x.channel.toLowerCase()) &&
            (x.customerType.includes(customer) || x.customerType === "")
        ),
      ]);
    } else {
      setStoreIdOptions([
        All_LOCATION,
        ...storeObjects.filter(
          (x) =>
            channelList.includes(x.channel.toLowerCase()) &&
            x.customerType.includes(customer)
        ),
      ]);
    }

    setDepotIdOptions([All_LOCATION, ...depotObjects]);
  }, [
    customer,
    locationResponse.length,
    channelList,
    storeObjects,
    depotObjects,
  ]);

  const handleChangeDepot = (event) => {
    const error1 = {};
    if (event.currentTarget.value === "") {
      error1.depotIdText = "Please select valid Depot Id";
      setDepoError(error1);
    } else {
      setDepoError(null);
    }
  };
  const handleChangeStore = (event) => {
    const error2 = {};
    if (event.currentTarget.value === "") {
      error2.storeIdText = "Please select valid Store Id";
      setStoreError(error2);
    } else {
      setStoreError(null);
    }
  };
  const handleCustomerChange = (event) => {
    setCustomer(event.target.value);
    setStoreId(["All"]);
    setDepotId(["All"]);
  };

  const validate = () => {
    const errors = {};

    if (!depotId) {
      errors.depotIdText = "Please select valid Depot Id";
    }

    if (!storeId) {
      errors.storeIdText = "Please select valid Store Id";
    }

    const isValidDate = (date) => date && dayjs(date).isValid();

    const hasDeliveryFrom = isValidDate(deliveryDateFrom);
    const hasDeliveryTo = isValidDate(deliveryDateTo);
    const hasOrderDate = isValidDate(orderDate);

    if (orderDate && !dayjs(orderDate).isValid()) {
      errors.orderDateText = "Please enter date in correct format ";
    }

    if (dayjs().diff(orderDate, "day") > 20) {
      errors.orderDateText =
        "You can select maximum 21 days before the today's date";
    }

    if (dayjs(orderDate).isAfter(dayjs())) {
      errors.orderDateText = "Order date cannot be more than today's date";
    }

    if (
      (deliveryDateFrom && !hasDeliveryFrom) ||
      (!deliveryDateFrom && deliveryDateTo)
    ) {
      errors.deliveryDateFromText = "Please enter valid date";
    }

    if (hasDeliveryFrom && dayjs().diff(deliveryDateFrom, "day") > 20) {
      errors.deliveryDateFromText =
        "You can select maximum 21 days before today's date";
    }
    if (
      hasDeliveryFrom &&
      orderDate &&
      dayjs(deliveryDateFrom).isBefore(dayjs(orderDate))
    ) {
      errors.deliveryDateFromText =
        "Delivery date from should be greater than order date";
    }

    if (
      (deliveryDateFrom && !deliveryDateTo) ||
      (deliveryDateTo && !hasDeliveryTo)
    ) {
      errors.deliveryDateToText = "Please enter valid date";
    }

    if (
      hasDeliveryFrom &&
      hasDeliveryTo &&
      dayjs(deliveryDateTo).isBefore(dayjs(deliveryDateFrom))
    ) {
      errors.deliveryDateToText =
        "Delivery date to should be greater than delivery date from";
    }

    if (!(hasDeliveryFrom && hasDeliveryTo) && !hasOrderDate) {
      errors.dateRequirementText =
        "Either Delivery Date range or Order Date must be provided";
    }

    setErrors(errors);

    return {
      isValid: Object.keys(errors).length === 0,

      errors,
    };
  };

  const handleDownloadFile = async (e) => {
    e.preventDefault();
    setShowFileDownloadPopup(true);
    const { isValid, errors } = validate();
    if (isValid) {
      const encryptedEmailId = await encryptString(loginResponse?.email);

      const request = {
        apiKey: SOMS_API_KEY,
        params: {
          customerId:
            channelList.length === 1 && customer === "All"
              ? WHOLESALE
              : customer.toLowerCase(),
          depotId:
            depotIdInputValue === "All"
              ? depotIdOptions
                  .filter((x) => typeof x.locationId === "number")
                  .map((x) => x.locationId)
              : [depotId],
          storeId:
            storeIdInputValue === "All"
              ? storeIdOptions
                  .filter((x) => typeof x.locationId === "number")
                  .map((x) => x.locationId)
              : [storeId],
          orderedDate: orderDate?.format("YYYY-MM-DDTHH:mm:ss") || null,
          deliveryDateFrom: deliveryDateFrom
            ? format(deliveryDateFrom, "yyyy-MM-dd'T'HH:mm:ss")
            : null,
          deliveryDateTo: deliveryDateTo
            ? `${format(deliveryDateTo, "yyyy-MM-dd")}T23:59:59`
            : null,
          customerOrderId: orderId,
          reportType: CUSTOMER_ORDERS_REPORT_TYPE,
          category: type,
          userId: encryptedEmailId,
        },
      };

      generateDownloadReport(request)
        .then((response) => {
          const { fileName } = response;

          const request = {
            apikey: SOMS_API_KEY,
            params: {
              fileName: fileName,
              reportType: CUSTOMER_ORDERS_REPORT_TYPE,
            },
          };

          postFileAccess(request)
            .then((response) => {
              const url = response.fileURL;
              const fileDownloadTag = document.createElement("a");
              fileDownloadTag.href = url;
              fileDownloadTag.click();
              setShowDownloadUrl(true);
              setDownloadUrl(response.fileURL);
              setDownloadFileTime(response.validUpto);
              setShowFileDownloadPopup(false);
              dispatch(
                showNotificationDialog(
                  "Download Successful",
                  DOWNLOAD_SUCCESS,
                  "Done"
                )
              );
            })
            .catch((err) => {
              const { errTitle, errContent } = showErrorMessageByCode(err);

              dispatch(showNotificationDialog(errTitle, errContent, "Done"));

              setShowFileDownloadPopup(false);
              return false;
            });
        })
        .catch((err) => {
          const { errTitle, errContent } = showErrorMessageByCode(err);

          dispatch(showNotificationDialog(errTitle, errContent, "Done"));

          setShowFileDownloadPopup(false);
          return false;
        });
    } else {
      const message = errors.dateRequirementText
        ? "Either Delivery Date range or Order Date must be provided"
        : CORRECT_VALUE_SELECTION;
      dispatch(showNotificationDialog("Download Failed", message, "Done"));

      setShowFileDownloadPopup(false);
      return false;
    }
  };

  const disablePastDate = (date) => {
    const day = dayjs().subtract(21, "day");
    return !dayjs(day).isBefore(date);
  };

  const handleDeliveryDateFromChange = (newDate) => {
    setDeliveryDateFrom(newDate);

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (!newDate || !dayjs(newDate).isValid()) {
        newErrors.deliveryDateFromText = "Please enter date in correct format";
      } else if (dayjs().diff(newDate, "day") > 20) {
        newErrors.deliveryDateFromText =
          "You can select maximum 21 days before today's date";
      } else if (orderDate && dayjs(newDate).isBefore(dayjs(orderDate))) {
        newErrors.deliveryDateFromText =
          "Delivery date from should be greater than order date";
      } else {
        delete newErrors.deliveryDateFromText;
      }

      return newErrors;
    });

    if (newDate) {
      const maxToDate = dayjs(newDate).add(2, "day").toDate();
      setDeliveryDateTo(maxToDate);
    }
  };

  const disableDeliveryDateFrom = (date) => {
    const minDate = dayjs().subtract(20, "day").startOf("day");

    return dayjs(date).isBefore(minDate);
  };

  // Handle Delivery Date To changes with validation
  const handleDeliveryDateToChange = (newDate) => {
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (disableDeliveryDateTo(newDate)) {
        newErrors.deliveryDateToText =
          "Delivery date to should be within range limit";
      } else {
        delete newErrors.deliveryDateToText;
      }

      return newErrors;
    });

    setDeliveryDateTo(newDate);
  };

  // Handle Order Date changes with validation
  const handleOrderDateChange = (newDate) => {
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (!newDate) {
        delete newErrors.orderDateText;
      } else if (dayjs(newDate).isAfter(dayjs())) {
        newErrors.orderDateText = "Order date cannot be more than today's date";
      } else if (dayjs().diff(newDate, "day") > 20) {
        newErrors.orderDateText =
          "You can select maximum 21 days before today's date";
      } else if (!dayjs(newDate).isValid()) {
        newErrors.orderDateText = "Please enter date in correct format";
      } else {
        delete newErrors.orderDateText;
      }
      return newErrors;
    });

    setOrderDate(newDate);
  };

  const disableDeliveryDateTo = (date) => {
    const fromDate = dayjs(deliveryDateFrom);
    const toDate = fromDate.add(2, "day");
    const currentDate = dayjs(date);
    return (
      currentDate.isBefore(fromDate, "day") ||
      currentDate.isAfter(toDate, "day")
    );
  };

  return (
    <>
      {showFileDownloadPopup ? (
        <Dialog open={showFileDownloadPopup} maxWidth="sm" fullWidth={true}>
          <DialogTitle>File Downloading</DialogTitle>
          <DialogContent>
            <LinearProgress />
            <Typography sx={{ mt: 1 }} variant="subtitle2">
              To ensure the successful download, please avoid clicking the back
              button, leaving the page, or refreshing it during the download
              process
            </Typography>
          </DialogContent>
        </Dialog>
      ) : (
        <div></div>
      )}
      <div className="labelControl">
        <Grid
          container
          spacing={2}
          sx={{ mb: 15 }}
          component="form"
          onSubmit={handleDownloadFile}
        >
          <Grid item xs={6} md={3}>
            <LabelWithControl
              label="Customer"
              labelId="customer"
              required={true}
            >
              <FormControl fullWidth size="small">
                {!customer && (
                  <InputLabel
                    id="customerLabel"
                    sx={{
                      "&.Mui-focused": { display: "none" },
                      "&.Mui-error": { color: "initial" },
                    }}
                    style={{ fontSize: "12px", top: "-4px" }}
                  >
                    Customer
                  </InputLabel>
                )}
                <Select
                  labelId="customerLabel"
                  id="customer"
                  className="dropDownValue"
                  value={customer}
                  onChange={handleCustomerChange}
                  disabled={
                    channelList.includes(ONLINE) && channelList.length === 1
                  }
                >
                  {customerList.map((x) => (
                    <MenuItem value={x.CustomerId}>{x.CustomerName}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </LabelWithControl>
          </Grid>
          <Grid item xs={6} md={3}>
            <LabelWithControl
              label="Depot ID"
              labelId="depotId"
              required={true}
            >
              <AutoComplete
                id="depotId"
                placeholderText="Depot ID"
                onInputChange={(event, newInputValue) => {
                  setDepotIdInputValue(newInputValue);
                }}
                inputValue={depotIdInputValue}
                onChange={(event, newValue) => {
                  setDepotId(newValue?.locationId);
                  handleChangeDepot(event);
                }}
                options={depotIdOptions}
                value={depotId}
                size="small"
                error={
                  !depotId ? errors?.depotIdText || depoError?.depotIdText : ""
                }
                required={true}
              />
            </LabelWithControl>
          </Grid>
          <Grid item xs={6} md={3}>
            <LabelWithControl
              label="Store ID"
              labelId="storeId"
              required={true}
            >
              <AutoComplete
                id="storeId"
                placeholderText="Store ID"
                onInputChange={(event, newInputValue) => {
                  setStoreIdInputValue(newInputValue);
                }}
                inputValue={storeIdInputValue}
                onChange={(event, newValue) => {
                  setStoreId(newValue?.locationId);
                  handleChangeStore(event);
                }}
                options={storeIdOptions}
                value={storeId}
                size="small"
                error={
                  !storeId ? errors?.storeIdText || storeError?.storeIdText : ""
                }
                required={true}
              />
            </LabelWithControl>
          </Grid>
          <Grid item xs={6} md={3}>
            <LabelWithControl label="Order Date">
              <DatePicker
                format="DD/MM/YYYY"
                disableFuture={true}
                onChange={handleOrderDateChange}
                shouldDisableDate={disablePastDate}
                slotProps={{
                  textField: {
                    size: "small",
                    helperText: errors?.orderDateText || "",
                    error: Boolean(errors?.orderDateText),
                    inputProps: { "data-testid": "order-date-input" },
                  },
                }}
              />
            </LabelWithControl>
          </Grid>
          <Grid item xs={6} md={3}>
            <LabelWithControl label="Delivery Date From">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  format="dd/MM/yyyy"
                  value={deliveryDateFrom}
                  onChange={handleDeliveryDateFromChange}
                  shouldDisableDate={disableDeliveryDateFrom}
                  slotProps={{
                    textField: {
                      size: "small",
                      placeholder: "Delivery Date From",
                      helperText: errors?.deliveryDateFromText || "",
                      error: Boolean(errors?.deliveryDateFromText),
                      inputProps: { "data-testid": "delivery-from-date-input" },
                    },
                  }}
                />
              </LocalizationProvider>
            </LabelWithControl>
          </Grid>
          <Grid item xs={6} md={3}>
            <LabelWithControl label="Delivery Date To">
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  format="dd/MM/yyyy"
                  value={deliveryDateTo}
                  shouldDisableDate={disableDeliveryDateTo}
                  onChange={handleDeliveryDateToChange}
                  slotProps={{
                    textField: {
                      size: "small",
                      placeholder: "Delivery Date To",
                      helperText: errors?.deliveryDateToText || "",
                      error: Boolean(errors?.deliveryDateToText),
                      inputProps: { "data-testid": "delivery-from-date-input" },
                    },
                  }}
                />
              </LocalizationProvider>
            </LabelWithControl>
          </Grid>
          <Grid item xs={6} md={3}>
            <LabelWithControl label="Type">
              <FormControl fullWidth size="small">
                <Select
                  labelId="type"
                  id="type"
                  value={type}
                  className="dropDownValue"
                  onChange={(x) => setType(x.target.value)}
                >
                  {downloadType.map((x) => (
                    <MenuItem value={x.DownloadTypeId}>
                      {x.DownloadTypeName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </LabelWithControl>
          </Grid>
          <Grid item xs={6} md={3}>
            <LabelWithControl label="Order ID" labelId="orderId">
              <TextField
                helperText={errors?.orderIdText || ""}
                error={errors?.orderIdText}
                value={orderId}
                onChange={(x) => setOrderId(x.target.value)}
                id="orderId"
                variant="outlined"
                size="small"
                placeholder="Order ID"
                inputProps={{ maxLength: 32 }}
              />
            </LabelWithControl>
          </Grid>
          <Grid container item sx={{ textAlign: "left", mt: 1 }}>
            <Grid item xs={4} md={2}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ "& a": { textDecoration: "none", color: "white" } }}
                style={{
                  fontSize: "12px",
                  marginTop: "17px",
                  height: "25px",
                  padding: "4px 10px",
                }}
              >
                Download File
              </Button>
            </Grid>
          </Grid>
          <Grid item>
            {showDownloadUrl ? (
              <Typography style={{ fontSize: "12px" }}>
                <Link color="primary" underline="none" href={downloadUrl}>
                  Click here
                </Link>{" "}
                to download the file. Valid till {downloadFileTime}.
              </Typography>
            ) : (
              <div></div>
            )}
          </Grid>
        </Grid>
      </div>
    </>
  );
};
